import React from "react";
import Buttons from '../Button/Button';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

function AddToCartBottomModal(props) {

    return (
        <div className="BottomCartSection">
            <div className="BottomCartContainer">
                <div className="CartLeftCol">
                    <CheckCircleRoundedIcon />
                    <p>You have added <a href="#"> Draw Islamic Geometric Patterns With A Compass And Ruler </a> to your cart!</p>
                </div>
                <div className="CartRightCol">
                    <div className="CartRightColInfo">
                        <p>4 items</p>
                        <h1>$58.99</h1>
                    </div>
                    <Buttons
                        label="Go to cart"
                        buttonColor="#fff"
                        color="#004FE0"
                        width="auto"
                        height="48px"
                        fontSize="14px"
                        border="#004FE0 1px solid"
                    // onClick={showAllBtnHandler}
                    />

                    <Buttons
                        label="Checkout"
                        buttonColor="#004FE0"
                        color="#fff"
                        width="auto"
                        height="48px"
                        fontSize="14px"
                        border="#004FE0 1px solid"
                    // onClick={showAllBtnHandler}
                    />
                </div>
            </div>
        </div>
    );
}

export default AddToCartBottomModal;
